<template>
  <ValidationProvider :name="$attrs.label" :rules="options">
    <v-textarea
      :disabled="$attrs.disabled"
      :error-messages="!$attrs.hideDetails ? errors : null"
      :placeholder="$attrs.placeholder"
      :success="!$attrs.hideValidations ? null : valid"
      background-color="white"
      filled
      slot-scope="{ errors, valid }"
      v-bind="$attrs"
      v-model="innerValue"
      v-on="$listeners"
    ></v-textarea>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
  },
  props: {
    options: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) this.innerValue = this.value;
    if (!this.value && this.$attrs.default) {
      this.innerValue = this.$attrs.default || "";
    }
  },
};
</script>
<style></style>
